import axios from 'axios';
import { useAuth } from '@/store/auth';

export const api = axios.create({
  baseURL: '/jee/api',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = useAuth.getState().token;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      useAuth.getState().logout();
      if (!window.location.pathname.endsWith('/login')) {
        window.location.href = '/jee/login';
      }
    }
    return Promise.reject(err);
  }
);
